import { StyleSheet, Text, View } from 'react-native'
import { ActionHint, Palette } from '@ppwr/poker'
import { InfoRectangle } from '../../InfoRectangle'

import { WalkthroughPlayersIds } from '../../../../models/game/walkthrough'
import { DS } from '../../../../design-system'

const playerIds: WalkthroughPlayersIds[] = ['bettina', 'esther', 'dianne', 'jane', 'tara']

export const DealTheFlop = ({
  onPlayerAction
}: {
  onPlayerAction: (action: ActionHint, selectedPlayerId: WalkthroughPlayersIds) => void
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.buttonsContainer}>
        {playerIds.map((id) => (
          <DS.Button
            key={`button-${id}`}
            variant="Large/Secondary"
            type="On Dark"
            style={styles.actionButton}
            onPress={() => onPlayerAction(ActionHint.BLANK, id)}
          >
            <Text style={styles.buttonText}>{id === 'bettina' ? 'Me' : id}</Text>
          </DS.Button>
        ))}
      </View>
      <InfoRectangle>
        <View style={styles.InfoContainer}>
          <View style={styles.dotStyle} />
          <DS.Text variant="Caption/Bold" uppercase>
            Who is winning this hand?
          </DS.Text>
        </View>
      </InfoRectangle>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: DS.spacing[16],
    gap: DS.spacing[16],
    height: 400
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
    marginHorizontal: 8,
    flexWrap: 'wrap'
  },
  buttonText: {
    textTransform: 'capitalize'
  },
  dotStyle: {
    height: 8,
    width: 8,
    backgroundColor: Palette['Brand/Orange'],
    borderRadius: 50
  },
  InfoContainer: {
    flexDirection: 'row',
    gap: DS.spacing[8],
    alignItems: 'center'
  },
  actionButton: {
    width: '30%',
    backgroundColor: DS.palette['Global/White']
  }
})
